@if (!httpError) {
  <div id="content-appraisal" class="appraisal">
    <section class="row">
      <div class="col-12">
        <h3 class="h-main h-main-medium corporate">{{ 'appraisal_title' | translate }}</h3>
      </div>
      <div class="col-12">
        <div class="primary-info-box highlight">
          <div class="row date-row">
            @if (status < minStatus.appraisal_done) {
              <div class="col-12">
                <p class="info-text">{{ 'appraisal_info_1' | translate }}</p>
              </div>
            }

            @if (status >= minStatus.appraisal_done && appraisal && appraisal.mortgagesAppraisalCrmData) {
              <div class="col-12">
                <p class="info-text">{{ 'appraisal_info_appraisal_done' | translate }}</p>
              </div>
            }
          </div>
        </div>
      </div>
      @if (status < minStatus.appraisal_done) {
        <app-simple-note
          class="col-12"
          [appraisal]="appraisal"
          [status]="status"
          (emitHasSimpleNote)="onEmitHasSimpleNote($event)"
          (emitUploadFile)="openModalUpload('simple_note_has_send_simple_note')"
          (emitMorgageAprraisalFile)="onEmitMorgageAprraisalFile($event)"
        ></app-simple-note>
      }
    </section>
    @if (status < minStatus.appraisal_done) {
      <section class="row">
        <app-appraisal-form
          [appraisal]="appraisal"
          [status]="status"
          #appraisalForm
          (emitHasAppraisal)="onEmitHasAppraisal($event)"
          (emitMortgageAppraisalData)="onEmitMortgageAppraisalData($event)"
          (emitMorgageAprraisalFile)="onEmitMorgageAprraisalFile($event)"
          (emitMortgageAppraisalDataSave)="onEmitMortgageAppraisalDataSave($event)"
          (emitAppraisalAmount)="onEmitAppraisalAmount($event)"
          (emitUploadFile)="openModalUpload('appraisal_form_upload_appraisal')"
        ></app-appraisal-form>
        <div class="d-flex justify-content-end col-12 send-appraisal-data">
          <button
            id="appraisal-content-btn-save"
            type="button"
            href="javascript:;"
            class="btn btn-01"
            (click)="saveAppraisal()"
          >
            {{ 'appraisal_btn_save' | translate }}
          </button>
          <button
            id="appraisal-content-btn-send"
            type="submit"
            href="javascript:;"
            class="btn btn-02"
            (click)="sendAppraisal()"
          >
            {{ 'appraisal_request' | translate }}
          </button>
        </div>
      </section>
    }
    @if (status >= minStatus.appraisal_done && appraisal && appraisal.mortgagesAppraisalCrmData) {
      <app-appraisal-result [appraisal]="appraisal"></app-appraisal-result>
    }
  </div>
} @else {
  <app-error-detail></app-error-detail>
}

<div hidden>
  <form #formTPV [formGroup]="tpv" name="form" [action]="urlTPV" method="POST">
    <input type="hidden" name="Ds_SignatureVersion" formControlName="Ds_SignatureVersion" />
    <input type="hidden" name="Ds_MerchantParameters" formControlName="Ds_MerchantParameters" />
    <input type="hidden" name="Ds_Signature" formControlName="Ds_Signature" />
    <!-- <button type="submit" class="btn btn-success" (click)="formTPV.submit()">Submit</button> -->
  </form>
</div>
